import React from 'react'
import { withIcon } from '../../withIcon'

function UserIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 5.07867C10.0305 5.07867 8.68598 6.69392 8.68598 8.3024C8.68598 9.91088 10.0305 11.6942 12 11.6942C13.9695 11.6942 15.314 9.91088 15.314 8.3024C15.314 6.69392 13.9695 5.07867 12 5.07867ZM7.58661 8.3024C7.58661 6.09819 9.3011 4 12 4C14.6989 4 16.4118 6.09819 16.4118 8.3024C16.4118 10.5066 14.6989 12.7729 12 12.7729C9.3011 12.7729 7.58661 10.5066 7.58661 8.3024ZM9.88679 14.8224C8.94102 14.8224 8.03399 15.1292 7.36522 15.6754C6.69646 16.2216 6.32075 16.9624 6.32075 17.7348V19.4607C6.32075 19.7585 6.02509 20 5.66038 20C5.29566 20 5 19.7585 5 19.4607V17.7348C5 16.6763 5.51486 15.6611 6.43131 14.9127C7.34776 14.1642 8.59073 13.7437 9.88679 13.7437H14.1132C15.4093 13.7437 16.6522 14.1642 17.5687 14.9127C18.4851 15.6611 19 16.6763 19 17.7348V19.4607C19 19.7585 18.7043 20 18.3396 20C17.9749 20 17.6792 19.7585 17.6792 19.4607V17.7348C17.6792 16.9624 17.3035 16.2216 16.6348 15.6754C15.966 15.1292 15.059 14.8224 14.1132 14.8224H9.88679Z" fill={color}/>
    </svg>
  )
}

export default withIcon(UserIcon)
